  <template>
    <div class="pt-8 flex flex-col lg:flex-row p-4 min-h-screen bg-light-bg dark:bg-dark-bg dark:text-dark-text">
      <AppSidebar />

      <div class="flex flex-col flex-grow p-6 lg:p-12 space-y-4 h-full">
      <div v-if="message" :class="messageType" 
          class="fixed top-0 left-0 right-0 z-5 p-4 rounded-lg mb-4 text-center 
                  bg-white dark:bg-dark-box-bg dark:text-dark-text dark:border 
                  dark:border-dark-border">
          {{ message }}
          <div class="absolute bottom-0 left-0 h-1 rounded-lg" 
              :style="{ width: progress + '%', backgroundColor: getProgressColor(), borderRadius: '8px' }">
          </div>
      </div>

        <h1 class="text-xl md:text-2xl font-bold mb-4 text-center lg:text-left">Zlecenia</h1>

        <div class="bg-white p-4 rounded-lg shadow-md w-full h-auto dark:bg-dark-box-bg dark:border dark:border-dark-border dark:text-dark-text">
          <div class="flex flex-col md:flex-row items-start md:items-center justify-between mb-4">
            <h2 class="text-lg font-semibold text-gray-700 dark:text-dark-text">Lista Zleceń:</h2>

            <div class="flex items-center space-x-4">
              <label for="status-filter" class="text-sm font-medium text-gray-700 dark:text-gray-300">Filtruj według:</label>
              <select id="status-filter" v-model="selectedStatus" @change="applyFilters"
                      class="block pl-3 pr-10 py-2 text-sm bg-light-bg text-light-text border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-md dark:bg-dark-box-bg dark:text-dark-text dark:border-dark-border w-full sm:w-48">
                <option value="ALL">Wszystkie statusy</option>
                <option value="">Wszystkie (bez zakończonych)</option>
                <option value="DO_OBSLUGI" class="text-light-text dark:text-gray-300">Do obsługi</option>
                <option value="WYSŁANE" class="text-light-text dark:text-gray-300">Wysłane</option>
                <option value="W_TRAKCIE" class="text-light-text dark:text-gray-300">W trakcie</option>
                <option value="PRZYJĘTE" class="text-light-text dark:text-gray-300">Przyjęte</option>
                <option value="ZAKONCZONY" class="text-light-text dark:text-gray-300">Zakończone</option>
                <option value="ANULOWANE" class="text-light-text dark:text-gray-300">Anulowane</option>
              </select>

              <label for="company-filter" class="text-sm font-medium text-gray-700 dark:text-gray-300">Firma:</label>
              <select id="company-filter" v-model="selectedCompany" @change="applyFilters"
                      class="block pl-3 pr-10 py-2 text-sm bg-light-bg text-light-text border border-gray-300 focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 rounded-md dark:bg-dark-box-bg dark:text-dark-text dark:border-dark-border w-full sm:w-48">
                <option value="">Wszystkie</option>
                <option v-for="company in companies" :key="company.id" :value="company.id">
                  {{ company.companyName }}
                </option>
              </select>
            </div>

          </div>

          <div class="w-full mb-4">
            <DynamicSearch
                :data="orders"
                :keysToSearch="['mpk', 'company.companyName', 'passenger.firstName', 'driverName', 'orderStatus', 'uniq_id']"
                @search-results="handleSearchResults"
                @clear-search="clearSearch"
                class="mt-4 dark:bg-dark-box-bg text-gray-900 dark:text-dark-text w-full md:w-auto"
                placeholder="Wyszukaj..."
            />
          </div>

          <div class="overflow-x-auto w-full">
            <table class="min-w-full bg-white border border-gray-300 rounded-lg dark:bg-dark-table-bg dark:border-dark-border">
              <thead>
              <tr class="bg-gray-50 dark:bg-dark-table-header dark:text-dark-text">
                <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  ID Zlecenia
                </th>
                <!-- <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  Data Zlecenia
                </th> -->
                <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  Firma
                </th>
                <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  Czas wyjazdu
                </th>
                <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  Miejscowość
                </th>
                <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  Pasażer
                </th>
                <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  Kierowca
                </th>
                <th class="py-2 md:py-3 px-2 md:px-4 text-left text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">
                  Status
                </th>
<!--               <th class="py-2 md:py-3 px-2 md:px-4 text-right text-xs md:text-sm font-semibold text-gray-700 dark:border-dark-border dark:text-dark-text">-->
<!--                 Akcje-->
<!--               </th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-if="paginatedOrders.length === 0">
                <td colspan="6" class="text-center py-4 text-red-500 font-semibold dark:text-dark-status-unavailable">
                  Brak zleceń
                </td>
              </tr>
              <tr
                  v-else
                  v-for="(order) in paginatedOrders"
                  :key="order.id"
                  :class="[
                    'border-b border-gray-300 dark:border-dark-border hover:bg-light-hover dark:hover:bg-dark-hover hover:cursor-pointer',
                    selectedOrder && order.id === selectedOrder.id ? 'bg-light-hover dark:bg-dark-hover' : ''
                  ]"
                  @click="showOrderDetails(order)"
              >
                <td @click.stop="startEditing(order)" class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">{{ order.mpk }}</td>
                <!-- <td class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">{{ order.date }}</td> -->
                <td class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">{{ order.company.companyName }}</td>
                <td class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">
                    {{ order.passenger[0] && order.passenger[0].pickupTime
                      ? order.passenger[0].pickupTime
                      : 'Brak przypisanego czasu'
                    }}
                </td>
                <td class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">
                    {{ order.passenger[0] && order.passenger[0].city ? getCityFromAddress(order.passenger[0].pickupAddress) : 'Brak przypisanej miejscowości'}}
                </td>
                <td class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">
                  <ul>
                    <li v-for="passenger in order.passenger" :key="passenger.passengerId">
                      {{ passenger.firstName }} {{ passenger.lastName }}
                    </li>
                  </ul>
                </td>
                <td class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">{{ order.driverName || 'Brak przypisanego kierowcy' }}</td>
                <td class="py-2 px-2 md:py-3 md:px-4 dark:text-dark-text">
                  <!-- Dodajemy kolorowe badge'y dla statusu jako klikalne -->
                  <button
                    v-if="getOrderStatusInPolish(order.orderStatus) === 'DO OBSŁUGI'"
                    :disabled="user.role === 'ROLE_YOUNG_DISPATCHER'"
                    @click.stop="user.role !== 'ROLE_YOUNG_DISPATCHER' && startEditing(order)"
                    class="inline-flex items-center bg-violet-500 text-white text-xs font-medium px-2 py-1 rounded-full focus:outline-none hover:bg-violet-900 transition-all truncate"
                    :class="{'opacity-50 cursor-not-allowed': user.role === 'ROLE_YOUNG_DISPATCHER'}"
                  >
                    <span class="w-1.5 h-1.5 bg-white rounded-full mr-1.5"></span>
                    DO OBSŁUGI
                  </button>
                  <button
                      v-else-if="getOrderStatusInPolish(order.orderStatus) === 'W TRAKCIE'"

                      class="inline-flex items-center bg-green-400 text-white text-xs font-medium px-2 py-1 rounded-full focus:outline-none hover:bg-green-500 transition-all truncate"
                  >
                    <span class="w-1.5 h-1.5 bg-white rounded-full mr-1.5"></span>
                    W TRAKCIE
                  </button>
                  <button
                      v-else-if="getOrderStatusInPolish(order.orderStatus) === 'ZAKOŃCZONY'"

                      class="inline-flex items-center bg-red-500 text-white text-xs font-medium px-2 py-1 rounded-full focus:outline-none hover:bg-red-600 transition-all truncate"
                  >
                    <span class="w-1.5 h-1.5 bg-white rounded-full mr-1.5"></span>
                    ZAKOŃCZONY
                  </button>
                  <button
                      v-else-if="getOrderStatusInPolish(order.orderStatus) === 'PRZYJĘTE'"

                      class="inline-flex items-center bg-blue-500 text-white text-xs font-medium px-2 py-1 rounded-full focus:outline-none hover:bg-blue-600 transition-all truncate"
                  >
                    <span class="w-1.5 h-1.5 bg-white rounded-full mr-1.5"></span>
                    PRZYJĘTE
                  </button>
                  <button
                      v-else-if="getOrderStatusInPolish(order.orderStatus) === 'WYSŁANE'"

                      class="inline-flex items-center bg-orange-500 text-white text-xs font-medium px-2 py-1 rounded-full focus:outline-none hover:bg-orange-600 transition-all truncate"
                  >
                    <span class="w-1.5 h-1.5 bg-white rounded-full mr-1.5"></span>
                    WYSŁANE
                  </button>

                  <button
                      v-else-if="getOrderStatusInPolish(order.orderStatus) === 'ANULOWANE'"

                      class="inline-flex items-center bg-purple-500 text-white text-xs font-medium px-2 py-1 rounded-full focus:outline-none hover:bg-purple-600 transition-all truncate"
                  >
                    <span class="w-1.5 h-1.5 bg-white rounded-full mr-1.5"></span>
                    ANULOWANE
                  </button>
                </td>


<!--               <td class="py-2 px-2 md:py-3 md:px-4 text-right dark:text-dark-text">-->
<!--                 <div class="relative inline-block text-left">-->
<!--                   <button @click.stop="toggleDropdown(order.id)" class="text-gray-500 hover:text-gray-700 dark:text-dark-text dark:hover:text-gray-400">-->
<!--                     <EllipsisVerticalIcon class="h-5 w-5" />-->
<!--                   </button>-->
<!--                   <div v-if="dropdownOpen === order.id" class="origin-top-right absolute left-0 ml-[-10rem] mt-[-2.2rem] w-40 focus:outline-none">-->
<!--                     <div class="py-1.5 absolute flex space-x-2 bg-gray-200 dark:bg-gray-900 rounded">-->
<!--                       <button-->
<!--                           @click.stop="goToProfile(order)"-->
<!--                           class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2"-->
<!--                       >-->
<!--                         <DocumentIcon class="w-4 h-4" />-->
<!--                       </button>-->
<!--                       <button-->
<!--                           v-if="user.role != 'ROLE_YOUNG_DISPATCHER'"-->
<!--                           @click.stop="startEditing(order)"-->
<!--                           class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2"-->
<!--                       >-->
<!--                         <PencilIcon class="w-4 h-4" />-->
<!--                       </button>-->
<!--                       <button-->
<!--                           v-if="user.role != 'ROLE_YOUNG_DISPATCHER'"-->
<!--                           @click.stop="deleteOrder(order.id)"-->
<!--                           class="text-left px-2 py-2 text-sm text-teal-700 dark:text-teal-400 flex items-center space-x-2"-->
<!--                       >-->
<!--                         <TrashIcon class="w-4 h-4" />-->
<!--                       </button>-->
<!--                     </div>-->
<!--                   </div>-->
<!--                 </div>-->
<!--               </td>-->
              </tr>
              </tbody>
            </table>
          </div>

          <div class="mt-4 flex flex-col sm:flex-row items-center justify-between space-y-4 sm:space-y-0">
            <!-- Informacja o liczbie wyświetlanych elementów -->
            <div class="text-center sm:text-left text-sm text-light-text dark:text-gray-400">
              Wyświetlono {{ (currentPage - 1) * itemsPerPage + paginatedOrders.length }} z {{ filteredOrders.length }} zleceń
            </div>

            <!-- Kontrolki paginacji -->
            <div class="flex flex-wrap justify-center sm:justify-end items-center gap-2">
              <!-- Przycisk "Pierwsza strona" -->
              <button v-if="currentPage > 1"
                      @click="goToPage(1)"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                Pierwsza strona
              </button>

              <!-- Przycisk "Poprzednia" -->
              <button v-if="currentPage > 1"
                      @click="prevPage"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                &laquo; Poprzednia
              </button>

              <!-- Numerowane strony -->
              <button v-for="page in visiblePages"
                      :key="page"
                      @click="goToPage(page)"
                      :class="[currentPage === page ? 'bg-teal-700 text-white' : 'bg-gray-200 dark:bg-dark-box-bg text-gray-700 dark:text-dark-text']"
                      class="px-3 py-1 text-sm font-medium rounded-md transition-colors hover:bg-teal-700 hover:text-white dark:hover:bg-teal-600 dark:hover:text-white">
                {{ page }}
              </button>

              <!-- Przycisk "Następna" -->
              <button v-if="currentPage < totalPages"
                      @click="nextPage"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                Następna &raquo;
              </button>

              <!-- Przycisk "Ostatnia strona" -->
              <button v-if="currentPage < totalPages"
                      @click="goToPage(totalPages)"
                      class="px-3 py-1 text-sm font-medium bg-light-table-header rounded-md dark:bg-dark-table-header dark:text-dark-text">
                Ostatnia strona
              </button>
            </div>
          </div>
        </div>


        <OrderInformationModal
            v-if="showModal"
            :visible="showModal"
            :title="'Szczegóły Zamówienia #' + (selectedOrder?.mpk || '')"
            :selectedOrder="selectedOrder"
            :userRole="user.role"
            @close="closeModalInformation"
            @goToProfile="goToProfile"
            @startEditing="startEditing"
            @deleteOrder="deleteOrder"
        >

        <div class="space-y-4">
            <p><b>Numer Zlecenia:</b> {{ selectedOrder?.mpk }}</p>
            <p><b>Unikalne ID:</b> {{ selectedOrder?.uniq_id || 'Brak unikalnego ID' }}</p>
            <p><b>Połaczone Zlecenie:</b> {{ selectedOrder?.orderlink || 'Brak połączonego zlecenia' }}</p>
            <p><b>Data:</b> {{ new Date(selectedOrder?.date).toLocaleDateString() }}</p>

            <div v-if="selectedOrder?.company">
              <p><b>Firma:</b> {{ selectedOrder?.company.companyName }}, NIP: {{ selectedOrder?.company.companyNip }}</p>
            </div>

            <div v-if="selectedOrder?.driver">
              <p><b>Kierowca:</b> {{ selectedOrder?.driver.firstName }} {{ selectedOrder?.driver.lastName }}</p>
            </div>

            <div v-if="selectedOrder?.passenger && selectedOrder.passenger.length > 0">
              <h3 class="text-lg font-semibold">Pasażerowie:</h3>
              <ul class="space-y-2">
                <li 
                  v-for="(passenger, index) in selectedOrder.passenger" 
                  :key="passenger.id || index"
                >
                  <p>#{{ index + 1 }}: {{ passenger.firstName }} {{ passenger.lastName }}</p>
                  <p>Skąd: {{ passenger.pickupAddress }}</p>
                  <p>Dokąd: {{ passenger.dropoffAddress }}</p>
                  <p>Godzina: {{ passenger.pickupTime }}</p>
                </li>
              </ul>
            </div>
          </div>
        </OrderInformationModal>


        <OrderCreateModal
            :isOpen="isModalOpen"
            :errors="errors"
            :orders="orders"
            @close="closeModal"
            @submit="handleOrderSubmit"
        />
        <OrderEditModal
            :isOpen="isEditModalOpen"
            :orderToEdit="editingOrder"
            :errors="errors"
            :orders="orders"
            @close="closeEditModal"
            @submit="handleOrderEditSubmit"
        />
      </div>

      <button
          :disabled="hasErrors"
          @click="openModal"
          class="fixed bottom-8 right-8 bg-button-bg text-button-text p-4 rounded-full shadow-md transition-transform duration-200 ease-in-out hover:bg-button-hover focus:outline-none focus:ring dark:bg-dark-button-bg dark:hover:bg-dark-button-hover"
      >
        <PlusIcon class="h-6 w-6 transition-transform duration-200 ease-in-out transform hover:rotate-45" />
      </button>
    </div>
  </template>



  <script>
  import { useAuthStore } from '@/stores/authStore';
  import orderService from '@/services/orderService';
  import companiesService from '@/services/companiesService';
  import passengersService from '@/services/passengersService';
  import driversService from '@/services/driversService';
  import AppSidebar from '@/components/AppSidebar.vue';
  import OrderCreateModal from './OrderCreateModal.vue';
  import OrderEditModal from './OrderEditModal.vue';
  import DynamicSearch from '../search/DynamicSearch.vue';

  // import { EllipsisVerticalIcon, DocumentIcon, PencilIcon, TrashIcon, PlusIcon } from "@heroicons/vue/24/solid";
  import { PlusIcon } from "@heroicons/vue/24/solid";

  import { OrderStatusMap } from '../utils/orderStatusMap';
  import OrderInformationModal from './OrderInformationModal.vue';
  import { useSessionStore } from '@/stores/useSessionStore';

  export default {
    name: "OrdersPageDispatcher",
    components: {
      // EllipsisVerticalIcon,
      // DocumentIcon,
      // PencilIcon,
      // TrashIcon,
      PlusIcon,
      AppSidebar,
      OrderCreateModal,
      OrderEditModal,
      DynamicSearch,
      OrderInformationModal,
    },
    setup() {
      const authStore = useAuthStore();
      const sessionStore = useSessionStore();
      if (authStore.isAuthenticated) {
        authStore.checkExpiration();
      }
      return { user: authStore.user, sessionStore };
    },
    data() {
      return {
        message: '',
        messageType: '',
        progress: 0,
        isModalOpen: false,
        isEditModalOpen: false,
        orders: [],
        editingOrder: null,
        filteredOrders: [],
        dropdownOpen: null,
        errors: {},
        companies: [],
        passengers: [],
        drivers: [],
        loading: false,
        showModal: false, // Kontrola widoczności modala
        selectedOrder: null, // Przechowywanie wybranego zamówienia
        currentPage: 1,
        itemsPerPage: 5, // Liczba elementów na stronę
        totalPages: 0, // Łączna liczba stron
        visiblePages: [], // Widoczne numery stron w paginacji
        selectedStatus: 'ALL',
        selectedCompany: '',
        isSearching: false, // Flaga kontrolująca wyszukiwanie
      };
    },
    computed: {
      paginatedOrders() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        const end = start + this.itemsPerPage;
        return this.filteredOrders.slice(start, end);
      },

      hasErrors() {
        return Object.values(this.errors).some(error => error !== '');
      }
    },
    mounted() {
      this.calculateItemsPerPage();
      window.addEventListener("resize", this.calculateItemsPerPage);
      this.fetchOrders();
      // this.fetchCompanies();
      //this.fetchPassengers();
      // this.fetchDrivers();

      this.calculateTotalPages();
      
      const pageFromUrl = parseInt(this.$route.query.currentPage) || 1;
      this.currentPage = pageFromUrl;

      this.startAutoRefresh();
    },
    beforeUnmount() {
      if (this.sessionStore.intervalId) {
        clearInterval(this.sessionStore.intervalId); // Oczyść interval, jeśli jest ustawiony
        this.sessionStore.intervalId = null; // Reset interval to prevent any issues if it tries to be cleared again
      }
      window.removeEventListener("resize", this.calculateItemsPerPage);
    },
    methods: {
      getCityFromAddress(fullAddress) {
        if (!fullAddress) {
          return 'Brak adresu';
        }
        
        const words = fullAddress.split(' ');
        if (words.length === 0) {
          return fullAddress;
        }

        const commonCitySuffixes = ['Wola', 'Góra', 'Nysa', 'Biała', 'Stara', 'Nowa', 'Mała', 'Wielka', 'Śląski']; 

        if (words.length >= 2 && commonCitySuffixes.includes(words[1])) {
          return `${words[0]} ${words[1]}`;
        }

        // console.log(words);

        return words[0];
      },
      calculateItemsPerPage() {
        const width = window.innerWidth;

        if (width >= 3840) {
          this.itemsPerPage = 24; // 4K monitor
        } else if (width >= 2560) {
          this.itemsPerPage = 15; // 2K monitor
        } else if (width >= 1920) {
          this.itemsPerPage = 8; // Full HD monitor
        } else {
          this.itemsPerPage = 5; // Standardowa wartość
        }

        this.calculateTotalPages();
      },
      startAutoRefresh() {
        this.sessionStore.startInterval(() => {
          if (!this.isSearching) {
            this.fetchOrders();
            // this.fetchCompanies();
            // this.fetchPassengers();
            // this.fetchDrivers();
          }
        }, 10000);
      },
      applyFilters() {
        let filtered = [...this.orders];

        // 1. Sortowanie danych (jeśli wybrano opcję sortowania)
        if (this.selectedStatus === 'mpk') {
          filtered.sort((a, b) => {
            // Sortowanie po dacie z MPK, a następnie po ID dla tej samej daty
            const dateA = this.extractDateFromMpk(a.mpk);
            const dateB = this.extractDateFromMpk(b.mpk);
            
            const dateComparison = new Date(dateB) - new Date(dateA);
            if (dateComparison === 0) {
              return b.id - a.id;
            }
            return dateComparison;
          });
          this.goToPage(1);
        } else if (this.selectedStatus) {
          // 2. Filtrowanie po konkretnym statusie
          if (this.selectedStatus !== 'ALL') {
            filtered = filtered.filter(order => order.orderStatus === this.selectedStatus);
            this.goToPage(1);
          }
          // this.goToPage(1);
        } else {
          // 3. Domyślne filtrowanie: wszystkie zlecenia bez zakończonych
          filtered = filtered.filter(order => order.orderStatus !== 'ZAKONCZONY');
          this.goToPage(1);
        }

        // 4. Filtrowanie według firmy
        if (this.selectedCompany) {
          filtered = filtered.filter(order => order.company.id === this.selectedCompany);
          this.goToPage(1);
        }

        this.filteredOrders = filtered;
        this.calculateTotalPages();
      },
      extractDateFromMpk(mpk) {
        const parts = mpk.split('/');
        return `${parts[1]}-${parts[2]}-${parts[3]}`; // Zwróć "YYYY-MM-DD"
      },
      filterByStatus() {
        if (this.selectedStatus) {
          switch (this.selectedStatus) {
            case 'mpk':
              // Sortowanie po numerze zlecenia (mpk) - najnowszy na górze
              this.filteredOrders = [...this.orders].sort((a, b) => {
                return b.mpk.localeCompare(a.mpk);
              });
              break;

            case 'date':
              // Sortowanie po dacie - najnowsza na górze
              this.filteredOrders = [...this.orders].sort((a, b) => {
                if (a.date && b.date) {
                  return new Date(b.date) - new Date(a.date);
                }
                return 0;
              });
              break;

            case 'orderStatus':
              // Sortowanie po statusie zlecenia (alfabetycznie)
              this.filteredOrders = [...this.orders].sort((a, b) => {
                return a.orderStatus.localeCompare(b.orderStatus);
              });
              break;

            // case 'driver':
            //   // Sortowanie po nazwisku kierowcy (alfabetycznie), zlecenia bez kierowcy na początku
            //   this.filteredOrders = [...this.orders].sort((a, b) => {
            //     // Sprawdzamy, czy kierowcy istnieją, jeśli nie, ustawiamy je na początku
            //     if (!a.driver && b.driver) return -1;  // a bez kierowcy, b z kierowcą
            //     if (a.driver && !b.driver) return 1;   // a z kierowcą, b bez kierowcy
                
            //     // Jeśli oba zlecenia mają kierowcę, sortujemy alfabetycznie po imieniu i nazwisku
            //     const driverA = a.driver ? `${a.driver.firstName} ${a.driver.lastName}` : '';
            //     const driverB = b.driver ? `${b.driver.firstName} ${b.driver.lastName}` : '';
            //     return driverA.localeCompare(driverB);
            //   });
            //   break;

            default:
              this.filteredOrders = [...this.orders];
              break;
          }
        } else {
          this.filteredOrders = [...this.orders];
        }

        this.calculateTotalPages();
      },
      showOrderDetails(order) {
        this.selectedOrder = order; // Przypisz wybrane zamówienie
        this.showModal = true; // Pokaż modal
      },
      closeModalInformation() {
        this.selectedOrder = null; // Wyczyść dane zamówienia
        this.showModal = false; // Zamknij modal
      },
      calculateTotalPages() {
        // 1. Oblicz nową całkowitą liczbę stron
        const newTotalPages = Math.ceil(this.filteredOrders.length / this.itemsPerPage);

        // 2. Jeśli bieżąca strona jest poza nowym zakresem, skoryguj ją.
        // Dzięki temu zostaniemy na tej samej stronie, chyba że ta strona już nie istnieje.
        if (this.currentPage > newTotalPages) {
          // Jeśli byłeś na stronie 3, a teraz są tylko 2, przenieś na stronę 2 (ostatnią).
          this.currentPage = Math.max(1, newTotalPages);
        }
        
        // 3. Aktualizuj stan komponentu
        this.totalPages = newTotalPages;
        this.updateVisiblePages();
      },
      // calculateTotalPages() {
      //   this.totalPages = Math.ceil(this.filteredOrders.length / this.itemsPerPage);
      //   this.updateVisiblePages();
      // },
      updateVisiblePages() {
        const range = 5; // Liczba stron do wyświetlenia na raz
        const start = Math.max(1, this.currentPage - Math.floor(range / 2));
        const end = Math.min(start + range - 1, this.totalPages);

        this.visiblePages = Array.from({ length: end - start + 1 }, (_, i) => start + i);
      },
      goToPage(page) {
        this.currentPage = page;
        this.updateVisiblePages();
      },
      nextPage() {
        if (this.currentPage < this.totalPages) {
          this.currentPage++;
          this.updateVisiblePages();
        }
      },
      prevPage() {
        if (this.currentPage > 1) {
          this.currentPage--;
          this.updateVisiblePages();
        }
      },
      showMessage(msg, type) {
        this.message = msg;
        this.messageType = type === 'success' ? 'success-message' : 'error-message';
        this.progress = 0;

        const interval = 30;
        const duration = 5000;
        const step = 100 / (duration / interval);

        const progressInterval = setInterval(() => {
          this.progress += step;
          if (this.progress >= 100) {
            clearInterval(progressInterval);
            this.progress = 0;
            this.message = '';
            this.messageType = '';
          }
        }, interval);
      },
      getProgressColor() {
        return this.messageType === 'success-message' ? '#16a34a' : '#b91c1c';
      },
      toggleDropdown(orderId) {
        this.dropdownOpen = this.dropdownOpen === orderId ? null : orderId;
      },
      openModal() {
        if (!this.isModalOpen) {
          this.isModalOpen = true;
        }
      },
      closeModal() {
        if (this.isModalOpen) {
          this.isModalOpen = false;
        }
      },
      openEditModal(order) {
        this.editingOrder = order;
        this.isEditModalOpen = true;
      },
      closeEditModal() {
        this.isEditModalOpen = false;
        this.editingOrder = null;
      },
      handleOrderSubmit(newOrder) {
        if (!this.loading) {
          this.submitCreate(newOrder);
        }
      },
      handleOrderEditSubmit(editedOrder) {
        if (!this.loading) {
          this.submitEdit(editedOrder);
        }
      },
      handleSearchResults(filteredData) {
        this.filteredOrders = filteredData;
        this.isSearching = filteredData.length > 0;

        this.goToPage(1);
      },
      clearSearch() {
        this.isSearching = false;

        this.goToPage(1);
      },
      async fetchOrders() {
        try {
          const response = await orderService.getAllOrders();
          this.orders = response.data.map(order => ({
            ...order,
            driverName: order.driver ? `${order.driver.lastName} ${order.driver.firstName}` : null,
          }));
          this.filteredOrders = this.orders;
          this.applyFilters();
          this.calculateTotalPages(); // Oblicz paginację
          //console.log(this.filteredOrders); // Debugowanie
        } catch (error) {
          console.error('Błąd podczas pobierania zamówień:', error);
        }
      },
      async fetchCompanies() {
        try {
          const response = await companiesService.getAllCompanies();
          this.companies = response.data;
        } catch (error) {
          console.error('Błąd podczas pobierania firm:', error);
        }
      },
      async fetchPassengers() {
        try {
          const response = await passengersService.getAllPassengers();
          this.passengers = response.data;
        } catch (error) {
          console.error('Błąd podczas pobierania pasażerów:', error);
        }
      },
      async fetchDrivers() {
        try {
          const response = await driversService.getAllDrivers();
          this.drivers = response.data;
        } catch (error) {
          console.error('Błąd podczas pobierania kierowców:', error);
        }
      },
      startEditing(order) {
        this.showModal = false;
        this.openEditModal(order);
      },
      getOrderStatusInPolish(orderStatus) {
        return OrderStatusMap[orderStatus] || 'Nieznany status';
      },
      async submitCreate(newOrder) {
        if (this.loading) return;

        this.loading = true;

        // console.log(newOrder);

        try {
          const orderData = {
            date: newOrder.date,
            orderLink: newOrder.orderlink,
            companyId: newOrder.companyId,
            uniq_id: newOrder.uniq_id,
            driverId: newOrder.driverId,
            // dispatcherId: this.user.uid,
            direction: newOrder.direction || false,
            return: newOrder.return || false,
            passengers: newOrder.passengers.map(passenger => ({
              passengerId: passenger.passengerId,
              passengerName: passenger.passengerName,
              firstName: passenger.firstName,
              lastName: passenger.lastName,
              pickupAddress: passenger.pickupAddress,
              dropoffAddress: passenger.dropoffAddress,
              pickupTime: passenger.pickupTime,
              swapped: passenger.swapped || false,
              swappedPassengerId: passenger.swappedPassengerId || null,
              sortOrder: passenger.sortOrder || null,
            })),
            orderStatus: 'DO_OBSLUGI'
          };

          await orderService.createOrder(orderData);
          this.showMessage("Zlecenie zostało pomyślnie dodane.", "success");

          await this.fetchOrders();
          this.resetNewOrder();
          this.closeModal();

          this.goToPage(1);

        } catch (error) {
          this.showMessage("Wystąpił błąd podczas dodawania zlecenia.", "error");
          console.error('Błąd podczas tworzenia zamówienia:', error);
        } finally {
          this.loading = false;
        }
      },
      async submitEdit(editedOrder) {
        if (this.loading) return;

        this.loading = true;
        try {
          const orderData = {
            mpk: editedOrder.mpk,
            date: editedOrder.date,
            orderLink: editedOrder.orderlink,
            companyId: editedOrder.company.id,
            passenger: editedOrder.passenger,
            driverId: editedOrder.driverId,
            direction: editedOrder.direction,
            return: editedOrder.return,
            // dispatcherId: this.user.uid,
            notesDispatcher: editedOrder.notesDispatcher,
            notesDriver: editedOrder.notesDriver,
            orderStatus: editedOrder.orderStatus
          };

          await orderService.updateOrder(editedOrder.id, orderData);
          this.showMessage("Zlecenie zostało pomyślnie zaktualizowane.", "success");

          await this.fetchOrders();
          this.closeEditModal();
        } catch (error) {
          this.showMessage("Wystąpił błąd podczas aktualizacji zlecenia.", "error");

          console.error('Błąd podczas aktualizacji zamówienia:', error);
        } finally {
          this.loading = false;
        }
      },
      async deleteOrder(orderId) {
        if (confirm("Czy na pewno chcesz usunąć to zamówienie?")) {
          try {
            await orderService.deleteOrder(orderId);
            await this.fetchOrders();
            this.showMessage("Zlecenie zostało pomyślnie usunięte.", "success");
            this.closeModalInformation();
          } catch (error) {
            console.error('Błąd podczas usuwania zamówienia:', error);
            this.showMessage("Wystąpił błąd podczas usuwania zlecenia.", "error");
          }
        }
      },
      resetNewOrder() {
        this.newOrder = {
          date: '',
          mpk: '',
          uniq_id: '',
          companyId: null,
          passengerId: null,
          driverId: null,
          pickupLocation: '',
          dropoffLocation: '',
          replacement: false,
          replacementPassengerAddress: '',
          replacementPassengerPhone: '',
          replacementPickupLocation: '',
          replacementDropoffLocation: '',
          orderStatus: 'NOWY'
        };
        this.resetErrors();
      },
      resetErrors() {
        this.errors = {
          mpk: '',
          uniq_id: '',
          companyId: '',
          passengerId: '',
          driverId: '',
          pickupLocation: '',
          dropoffLocation: '',
          replacementPassengerAddress: '',
          replacementPassengerPhone: '',
          replacementPickupLocation: '',
          replacementDropoffLocation: '',
        };
      },
      goToProfile(order) {
        const currentPage = this.currentPage;

        if (this.user.role === 'ROLE_ADMIN') {
          this.$router.push({
            name: 'OrderProfileAdmin', 
            params: {id: order.id},
            query: { returnTo: this.$route.name, currentPage: currentPage }
          });
        } else {
          this.$router.push({name: 'OrderProfileDispatcher', params: {id: order.id}, query: {currentPage: currentPage}});
        }
      }
    }
  };
  </script>